/*eslint-disable*/
import request from '@/api/request'

/**
 * 获取签名
 * @param id
 */
export const getSignature = (type) => {
  const data = {
    isPrivate: type
  }
  return request({
    url: '/admin/file/admin/web/ossSignInfo',
    method: 'post',
    data
  })
}

export const ossAccountInfo = (type) => {
  const data = {
    isPrivate: type
  }
  return request({
    url: '/admin/file/admin/web/ossAccountInfo',
    method: 'post',
    data
  })
}

/**
 * **/
export const getpublicImgUrl = (fileName) => {
  const data = {
    fileName: fileName
  }
  return request({
    url: '/admin/file/admin/public/wholeUrl',
    data,
    method: 'post'
  })
}

export const getPrivateImgUrl = (fileName) => {
  const data = {
    fileName: fileName
  }
  return request({
    url: '/admin/file/admin/personal/wholeUrl',
    data,
    method: 'post'
  })
}